import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { Loading } from '../helpers/loading.helper';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private totalRequests = 0;

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (!request.url.includes("TokenRefresh") && !request.url.includes("OsveziToken")) {
      if (this.totalRequests == 0) {
        Loading.show();
      }

      this.totalRequests++;
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!request.url.includes("TokenRefresh") && !request.url.includes("OsveziToken")) {
          this.totalRequests--;
          if (this.totalRequests === 0) {
            Loading.hide();
          }
        }
      })
    );
  }
}